import { Helmet } from "react-helmet-async";
import { appInsightsInstrumentationKey, azureRegion, resourceAddress } from "../../utils/sharedUtilities";

function Header() {    
    return (
        <>
            {/*XUACompat needs to be the FIRST meta tag*/}
            <Helmet>
                <meta http-equiv="X-UA-Compatible" content="IE=edge, chrome=1" />
                <meta charset="utf-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                <meta http-equiv="X-UA-Compatible" content="IE=Edge" />
                <meta name="description" content="FEMA�s RadResponder Network provides an important resource for federal, state, local, tribal, and territorial organizations responding to radiological/nuclear emergencies. The purpose of RadResponder is to provide a free standardized radiation data collection and management tool for all levels of government and industry. The RadResponder Network enables organizations to rapidly record, share and aggregate radiological data, manage specialized personnel and equipment, and establish interagency partnerships." />
                <meta name="azure-region" content={azureRegion} />

                <link rel="apple-touch-icon" sizes="72x72" href={`${resourceAddress}/v1/favicons/iPad_regular_icon.png`} />
                <link rel="apple-touch-icon" sizes="114x114" href={`${resourceAddress}/v1/favicons/iPhone_retina_icon.png`} />
                <link rel="apple-touch-icon" sizes="144x144" href={`${resourceAddress}/v1/favicons/iPad_retina_icon.png`} />
                <link rel="apple-touch-icon" href={`${resourceAddress}/v1/favicons/iPhone_regular_icon.png`} />
                <link rel="icon" href={`${resourceAddress}/v1/favicons/cbrn/favicon.png`} />
            </Helmet>

            {/* App Insights */}
            <Helmet>
                <script src="https://az416426.vo.msecnd.net/scripts/b/ai.2.min.js" />
                <script type="text/javascript">{`
                    var key = "${appInsightsInstrumentationKey}";
                    if (key !== "") {
                        var init = new Microsoft.ApplicationInsights.ApplicationInsights({
                                            config: {
                                            instrumentationKey: key,
                                enableAutoRouteTracking: true,
                                autoTrackPageVisitTime: true
                            }
                        });
                        window.appInsights = init.loadAppInsights();
                        window.appInsights.trackPageView();
                    }
                `}
                </script>
            </Helmet>

            {/* Don't index identity irregardless of config. */}
            <Helmet>
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>

            {/*Blackberry*/}
            <Helmet>
                <meta name="HandheldFriendly" content="true" />
            </Helmet>
            {/*iOS - no zoom*/}
            <Helmet>
                <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
            </Helmet>
        </>
    );
}

export default Header;